import { css } from "@mui/material";

export const mainContainer = css`
    position: absolute;
    left: 5px;
    top: 5px;
`

export const chartContainer = css`
    display: flex;
    width: 300px;
    position: absolute;
    flex-direction: column;
    border-radius: 6px;
    // border: 1px solid #e9ecef;
`

export const chartHeader = (isOpen) => css`
    display: flex;
    padding: 9px 10px;
    background-color: #004F9E;
    color: #fff;
    border-radius: ${isOpen ? "5px 5px 0px 0px" : "5px"};
    border-bottom: none;
    cursor: pointer;
`

export const headerText = css`
    width: 100%;
    padding: 5px 0px 0px 5px;
`

export const foldButton = css`
    cursor: pointer;
`

export const chartArea = css`
    display: flex;
    background: #ffffff;
    min-height: 320px;
    justify-content: center;
    align-items: center;
    padding: 5px 5px;
`;

export const textContainer = css`
    text-align: center;
`

export const chartIcon = css`
    display: flex;
    font-size: 20px;
    padding: 7px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    cursor: pointer;

    &:hover {
        filter: blur(0.5px);
    }
`